var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, "enforce-focus": false },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "select-item",
            title: "商品選択",
            size: "xl",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
          },
          on: { hidden: _vm.onModalHide },
        },
        [
          _c("div", [
            _c(
              "div",
              { staticStyle: { width: "1200px" } },
              [
                _c("b-table-filter-pager", {
                  attrs: {
                    maxHeight: _vm.maxHeight,
                    filter_list: _vm.filter_list,
                    filter_val: _vm.filter_val,
                    busy: _vm.busy,
                    filter_val_ex: _vm.filter_val_ex,
                    data_list_field: _vm.data_list_field,
                    data_list: _vm.data_list,
                    edit_disabled: _vm.pms_master_item < 2,
                    data_count: _vm.data_count,
                    currentPage: _vm.current_page,
                    filter_enable: true,
                    nav_flg: true,
                  },
                  on: {
                    on_sort: _vm.onSort,
                    on_edit: _vm.onEdit,
                    on_add: _vm.onEdit,
                    on_page_change: _vm.onPageChange,
                    on_select: _vm.onSelect,
                    on_filter_ex: _vm.onFilterEx,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-item_edit",
            title: _vm.title,
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
          },
          on: { hidden: _vm.onModalItemEditHide },
        },
        [
          _c("div", { staticClass: "modal_div" }, [
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label" }, [
                  _vm._v("商品コード"),
                ]),
                _vm._v(" "),
                _c("b-input", {
                  attrs: { type: "text" },
                  model: {
                    value: _vm.item.item_code,
                    callback: function ($$v) {
                      _vm.$set(_vm.item, "item_code", $$v)
                    },
                    expression: "item.item_code",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label" }, [
                  _vm._v("商品分類"),
                ]),
                _vm._v(" "),
                _c(
                  "b-form-select",
                  {
                    staticStyle: { width: "180px" },
                    model: {
                      value: _vm.item.item_type_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.item, "item_type_id", $$v)
                      },
                      expression: "item.item_type_id",
                    },
                  },
                  _vm._l(_vm.sel_item_type, function (option) {
                    return _c(
                      "option",
                      { key: option.id, domProps: { value: option.value } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(option.text) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label" }, [_vm._v("発注先")]),
                _vm._v(" "),
                _c(
                  "b-form-select",
                  {
                    staticStyle: { width: "200px" },
                    model: {
                      value: _vm.item.hattyu_company_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.item, "hattyu_company_id", $$v)
                      },
                      expression: "item.hattyu_company_id",
                    },
                  },
                  _vm._l(_vm.sel_hattyu_company, function (option) {
                    return _c(
                      "option",
                      { key: option.id, domProps: { value: option.value } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(option.text) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label" }, [_vm._v("商品名")]),
                _vm._v(" "),
                _c("b-input", {
                  staticStyle: { width: "350px" },
                  attrs: { type: "text" },
                  model: {
                    value: _vm.item.item_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.item, "item_name", $$v)
                    },
                    expression: "item.item_name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label" }, [
                  _vm._v("仕入れ単価"),
                ]),
                _vm._v(" "),
                _c("b-input", {
                  staticStyle: { width: "150px" },
                  attrs: { type: "number" },
                  model: {
                    value: _vm.item.hattyu_tanka,
                    callback: function ($$v) {
                      _vm.$set(_vm.item, "hattyu_tanka", $$v)
                    },
                    expression: "item.hattyu_tanka",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label" }, [_vm._v("単価")]),
                _vm._v(" "),
                _c("b-input", {
                  staticStyle: { width: "150px" },
                  attrs: { type: "number" },
                  model: {
                    value: _vm.item.tanka,
                    callback: function ($$v) {
                      _vm.$set(_vm.item, "tanka", $$v)
                    },
                    expression: "item.tanka",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label" }, [
                  _vm._v("税率(%)"),
                ]),
                _vm._v(" "),
                _c(
                  "b-form-select",
                  {
                    staticStyle: { width: "120px" },
                    model: {
                      value: _vm.item.tax_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.item, "tax_id", $$v)
                      },
                      expression: "item.tax_id",
                    },
                  },
                  _vm._l(_vm.sel_tax, function (option) {
                    return _c(
                      "option",
                      { key: option.id, domProps: { value: option.value } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(option.text) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", { staticClass: "block_label" }, [
                  _vm._v("発注区分"),
                ]),
                _vm._v(" "),
                _c(
                  "b-form-select",
                  {
                    staticStyle: { width: "100px" },
                    model: {
                      value: _vm.item.hattyu_cycle_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.item, "hattyu_cycle_id", $$v)
                      },
                      expression: "item.hattyu_cycle_id",
                    },
                  },
                  _vm._l(_vm.sel_hattyu_cycle, function (option) {
                    return _c(
                      "option",
                      { key: option.id, domProps: { value: option.value } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(option.text) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _c(
                "b-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.hide("modal-item_edit")
                    },
                  },
                },
                [
                  _c("b-icon", { attrs: { icon: "x" } }),
                  _vm._v("取消\n      "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: { click: _vm.updateItem },
                },
                [
                  _c("b-icon", { attrs: { icon: "save" } }),
                  _vm._v(" 保存\n      "),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }